/**
 * Checkbox Component (Radix)
 * For Media Devoted | Created By Ciro Autiero
 */

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

export type CheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>;

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // align-middle: an EMPTY inline-block (unchecked — Radix unmounts the
      // indicator) baseline-aligns at its bottom edge and stretches the line
      // box, so table rows jitter by checked state without it.
      'peer h-4 w-4 shrink-0 rounded align-middle border border-input bg-background ring-offset-background',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-primary-foreground',
      'data-[state=indeterminate]:bg-muted data-[state=indeterminate]:border-muted-foreground data-[state=indeterminate]:text-muted-foreground',
      'cursor-pointer transition-colors',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center">
      {props.checked === 'indeterminate'
        ? <Minus className="h-2.5 w-2.5" strokeWidth={3} />
        : <Check className="h-2.5 w-2.5" strokeWidth={3} />
      }
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = 'Checkbox';
